
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire03e2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire03e2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8eOUE", function(module, exports) {

$parcel$export(module.exports, "subscribeToSloganChange", () => $0521432beee826b2$export$dfa88baa90e85fb6);
$parcel$export(module.exports, "init", () => $0521432beee826b2$export$2cd8252107eb640b);

var $1LIL3 = parcelRequire("1LIL3");

var $g8FP8 = parcelRequire("g8FP8");

var $j8Uso = parcelRequire("j8Uso");
/**
 * Handles all Pocketbase stuff that is used by everyone (attendee, chaperone, admin)
 * This includes, but is not limited to
 * - Logging in
 * - Handling userlending (see README.md)
 * - Loading in slogans
 * - Initialise notify.ts
 * - Subscribe to - and display - slogans & pings information
 */ let $0521432beee826b2$var$pb;
let $0521432beee826b2$var$lendUsernameGlobal = false;
async function $0521432beee826b2$var$login(username, passInput, tryAdminLogin = false) {
    const login = !tryAdminLogin ? $0521432beee826b2$var$pb.collection("users") : $0521432beee826b2$var$pb.admins;
    try {
        // @ts-ignore
        return {
            success: true,
            data: await login.authWithPassword(username, passInput.value)
        };
    } catch (err) {
        (0, $g8FP8.error)(err.response.message);
        return {
            success: false,
            data: err
        };
    }
}
async function $0521432beee826b2$var$loginWithPassword(e) {
    e.preventDefault();
    const username = $("#username").val();
    const passInput = document.getElementById("password");
    const tryAdminLogin = $("#try-admin-login").is(":checked");
    if (passInput.value) {
        let auth;
        if (!$0521432beee826b2$var$lendUsernameGlobal) auth = await $0521432beee826b2$var$login(username, passInput, tryAdminLogin);
        else {
            // Try to log in with username
            auth = await $0521432beee826b2$var$login(username, passInput, tryAdminLogin);
            if (!auth.success) {
                console.log(`Couldn't login to ${username}. Lending username...`);
                const chaperones = await $0521432beee826b2$var$pb.collection("users").getFullList();
                let i = 0;
                for(let i = 0; i < chaperones.length; i++){
                    console.log(`Trying ${chaperones[i].username} (id: ${chaperones[i].id})`);
                    auth = await $0521432beee826b2$var$login(chaperones[i].username, passInput, tryAdminLogin);
                    if (auth.success) break;
                }
                if (!auth.success) (0, $g8FP8.error)("Couldn't lend username!");
                else {
                    if ($0521432beee826b2$var$pb.authStore.model) try {
                        await $0521432beee826b2$var$pb.collection("users").update($0521432beee826b2$var$pb.authStore.model.id, {
                            username: username
                        });
                    } catch (e) {
                        console.log("Error while changing username");
                        console.log(e);
                    }
                }
            }
        }
        if (auth.success) {
            (0, $g8FP8.success)("Logged in!");
            const loginForm = document.getElementById("loginForm");
            loginForm.style.display = "none";
            $0521432beee826b2$var$loggedIn();
        }
    }
}
const $0521432beee826b2$var$slogans = $("#slogans ol") // TODO move up
;
function $0521432beee826b2$var$addSlogan(sloganRecord) {
    $0521432beee826b2$var$slogans.append(`<li id="${sloganRecord.id}">${sloganRecord.text}</li>`);
}
function $0521432beee826b2$var$updateSlogan(sloganRecord) {
    $("#" + sloganRecord.id).text(sloganRecord.text);
}
function $0521432beee826b2$var$deleteSlogan(sloganRecord) {
    $("#" + sloganRecord.id).remove();
}
function $0521432beee826b2$export$dfa88baa90e85fb6(addSloganElement = $0521432beee826b2$var$addSlogan, updateSloganElement = $0521432beee826b2$var$updateSlogan, deleteSloganElement = $0521432beee826b2$var$deleteSlogan) {
    return $0521432beee826b2$var$pb.collection("slogans").subscribe("*", function(data) {
        switch(data.action){
            case "create":
                addSloganElement(data.record);
                break;
            case "update":
                updateSloganElement(data.record);
                break;
            case "delete":
                deleteSloganElement(data.record);
                break;
            default:
                throw new Error("Unimplemented action: " + data.action);
        }
    });
}
async function $0521432beee826b2$var$loggedIn() {
    // Remove initial hiding class
    $("main").removeClass("loading");
    // Hide loading & login
    $("#loading").hide();
    $("#loginForm").hide();
    $("#logout").show();
    try {
        (await $0521432beee826b2$var$pb.collection("slogans").getFullList()).forEach($0521432beee826b2$var$addSlogan);
        $0521432beee826b2$export$dfa88baa90e85fb6();
        $0521432beee826b2$var$pb.collection("ping").subscribe("*", function(data) {
            if (data.action == "update") {
                const currentSlogan = data.record.currentslogan;
                const chaperone = data.record.chaperone;
                const chaperoneNickname = data.record.chaperone_nickname;
                const message = data.record.message;
                if (currentSlogan) {
                    const oldSlogan = $("." + chaperone).removeClass(chaperone);
                    // If it's no other chaperones current slogan
                    if (oldSlogan.attr("class") == "current-slogan") oldSlogan.removeClass("current-slogan");
                    $("#" + currentSlogan).addClass(chaperone).addClass("current-slogan");
                    // TODO: move this code to a better spot?
                    (0, $g8FP8.info)(`${chaperoneNickname}: Slogan changed to ${$("#" + currentSlogan).text()}`).on((0, $j8Uso.NotyfEvent).Click, ({ target: target, event: event })=>{
                        if ($("#editor-current-slogan ol li").length > 0) window.location.hash = "#current-" + currentSlogan;
                        else if ($("#editor-change-slogans ol li").length > 0) ;
                        else window.location.hash = "#" + currentSlogan;
                    });
                }
                if (message) {
                    const msg = message.toLowerCase();
                    if (msg.includes("urgent") || msg.includes("life-threatening") || msg.includes("police")) (0, $g8FP8.error)(message);
                    else if (msg.includes("when possible")) (0, $g8FP8.warning)(message);
                    else if (msg.includes("incoming")) (0, $g8FP8.info)(message);
                    else {
                        console.log("Couldn't determine urgency, send as info");
                        (0, $g8FP8.info)(message);
                    }
                }
            }
        });
    } catch (err) {
        console.error("Error while retrieving slogans" + ($0521432beee826b2$var$pb.authStore.isAdmin ? `. Please go to ${window.location.origin}/maintainer.html, use the setup collections button` : ""));
        console.error(err);
    }
    // Show slogans for everyone logged in
    $("#slogans").show(400);
    // Show settings to chaperone && admins
    let usr = $0521432beee826b2$var$pb.authStore.model ? $0521432beee826b2$var$pb.authStore.model.username : "";
    if (usr == "chaperone" || $0521432beee826b2$var$pb.authStore.isAdmin) $("#send-signal").show(400);
    if ($0521432beee826b2$var$pb.authStore.isAdmin) $("#admin-settings").show();
}
function $0521432beee826b2$export$2cd8252107eb640b({ justReturnPb: justReturnPb = false, tryWithoutAuth: tryWithoutAuth = false, lendUsername: lendUsername = false }) {
    $0521432beee826b2$var$lendUsernameGlobal = lendUsername;
    // Init notifications
    (0, $g8FP8.init)();
    const pocketBaseUrl = "https://pocketbase.neonpastel.net";
    if (!pocketBaseUrl) {
        alert("No database url could be found. Please report this to the site admin!");
        return $0521432beee826b2$var$pb;
    }
    $0521432beee826b2$var$pb = new (0, $1LIL3.default)(pocketBaseUrl);
    if (justReturnPb) return $0521432beee826b2$var$pb;
    $(window).on("load", async function() {
        // If not logged in
        if (!$0521432beee826b2$var$pb.authStore.isValid) {
            // For index/attendee page, still try without auth
            if (tryWithoutAuth) {
                const data = await $0521432beee826b2$var$pb.collection("slogans").getList(1, 1); // Return 1
                if (data.totalItems == 0) (0, $g8FP8.warning)("No slogans could be loaded. Are you logged in?");
                else {
                    // TODO: cleaner solution
                    $0521432beee826b2$var$loggedIn();
                    return $0521432beee826b2$var$pb;
                }
            }
            // Remove initial hiding class
            $("main").removeClass("loading");
            // Hide all shown elements
            $("main > *").hide();
            // Enable & show login
            $("#loginForm").on("submit", $0521432beee826b2$var$loginWithPassword).show();
        } else $0521432beee826b2$var$loggedIn();
    });
    return $0521432beee826b2$var$pb;
}

});
parcelRegister("1LIL3", function(module, exports) {

$parcel$export(module.exports, "ClientResponseError", () => $5582cf41b70f685b$export$dcaf143e197b2cd2);
$parcel$export(module.exports, "default", () => $5582cf41b70f685b$export$2e2bcd8739ae039);
class $5582cf41b70f685b$export$dcaf143e197b2cd2 extends Error {
    constructor(e){
        super("ClientResponseError"), this.url = "", this.status = 0, this.response = {}, this.isAbort = !1, this.originalError = null, Object.setPrototypeOf(this, $5582cf41b70f685b$export$dcaf143e197b2cd2.prototype), null !== e && "object" == typeof e && (this.url = "string" == typeof e.url ? e.url : "", this.status = "number" == typeof e.status ? e.status : 0, this.isAbort = !!e.isAbort, this.originalError = e.originalError, null !== e.response && "object" == typeof e.response ? this.response = e.response : null !== e.data && "object" == typeof e.data ? this.response = e.data : this.response = {}), this.originalError || e instanceof $5582cf41b70f685b$export$dcaf143e197b2cd2 || (this.originalError = e), "undefined" != typeof DOMException && e instanceof DOMException && (this.isAbort = !0), this.name = "ClientResponseError " + this.status, this.message = this.response?.message, this.message || (this.isAbort ? this.message = "The request was autocancelled. You can find more info in https://github.com/pocketbase/js-sdk#auto-cancellation." : this.originalError?.cause?.message?.includes("ECONNREFUSED ::1") ? this.message = "Failed to connect to the PocketBase server. Try changing the SDK URL from localhost to 127.0.0.1 (https://github.com/pocketbase/js-sdk/issues/21)." : this.message = "Something went wrong while processing your request.");
    }
    get data() {
        return this.response;
    }
    toJSON() {
        return {
            ...this
        };
    }
}
const $5582cf41b70f685b$var$e = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
function $5582cf41b70f685b$export$2314e25186e9360(e, t) {
    const s = {};
    if ("string" != typeof e) return s;
    const i = Object.assign({}, t || {}).decode || $5582cf41b70f685b$var$defaultDecode;
    let n = 0;
    for(; n < e.length;){
        const t = e.indexOf("=", n);
        if (-1 === t) break;
        let r = e.indexOf(";", n);
        if (-1 === r) r = e.length;
        else if (r < t) {
            n = e.lastIndexOf(";", t - 1) + 1;
            continue;
        }
        const o = e.slice(n, t).trim();
        if (void 0 === s[o]) {
            let n = e.slice(t + 1, r).trim();
            34 === n.charCodeAt(0) && (n = n.slice(1, -1));
            try {
                s[o] = i(n);
            } catch (e) {
                s[o] = n;
            }
        }
        n = r + 1;
    }
    return s;
}
function $5582cf41b70f685b$export$879d2f108927fb90(t, s, i) {
    const n = Object.assign({}, i || {}), r = n.encode || $5582cf41b70f685b$var$defaultEncode;
    if (!$5582cf41b70f685b$var$e.test(t)) throw new TypeError("argument name is invalid");
    const o = r(s);
    if (o && !$5582cf41b70f685b$var$e.test(o)) throw new TypeError("argument val is invalid");
    let a = t + "=" + o;
    if (null != n.maxAge) {
        const e = n.maxAge - 0;
        if (isNaN(e) || !isFinite(e)) throw new TypeError("option maxAge is invalid");
        a += "; Max-Age=" + Math.floor(e);
    }
    if (n.domain) {
        if (!$5582cf41b70f685b$var$e.test(n.domain)) throw new TypeError("option domain is invalid");
        a += "; Domain=" + n.domain;
    }
    if (n.path) {
        if (!$5582cf41b70f685b$var$e.test(n.path)) throw new TypeError("option path is invalid");
        a += "; Path=" + n.path;
    }
    if (n.expires) {
        if (!function isDate(e) {
            return "[object Date]" === Object.prototype.toString.call(e) || e instanceof Date;
        }(n.expires) || isNaN(n.expires.valueOf())) throw new TypeError("option expires is invalid");
        a += "; Expires=" + n.expires.toUTCString();
    }
    if (n.httpOnly && (a += "; HttpOnly"), n.secure && (a += "; Secure"), n.priority) switch("string" == typeof n.priority ? n.priority.toLowerCase() : n.priority){
        case "low":
            a += "; Priority=Low";
            break;
        case "medium":
            a += "; Priority=Medium";
            break;
        case "high":
            a += "; Priority=High";
            break;
        default:
            throw new TypeError("option priority is invalid");
    }
    if (n.sameSite) switch("string" == typeof n.sameSite ? n.sameSite.toLowerCase() : n.sameSite){
        case !0:
            a += "; SameSite=Strict";
            break;
        case "lax":
            a += "; SameSite=Lax";
            break;
        case "strict":
            a += "; SameSite=Strict";
            break;
        case "none":
            a += "; SameSite=None";
            break;
        default:
            throw new TypeError("option sameSite is invalid");
    }
    return a;
}
function $5582cf41b70f685b$var$defaultDecode(e) {
    return -1 !== e.indexOf("%") ? decodeURIComponent(e) : e;
}
function $5582cf41b70f685b$var$defaultEncode(e) {
    return encodeURIComponent(e);
}
const $5582cf41b70f685b$var$t = "undefined" != typeof navigator && "ReactNative" === navigator.product || "undefined" != typeof $parcel$global && $parcel$global.HermesInternal;
let $5582cf41b70f685b$var$s;
function $5582cf41b70f685b$export$26ddc56bc995240a(e) {
    if (e) try {
        const t = decodeURIComponent($5582cf41b70f685b$var$s(e.split(".")[1]).split("").map(function(e) {
            return "%" + ("00" + e.charCodeAt(0).toString(16)).slice(-2);
        }).join(""));
        return JSON.parse(t) || {};
    } catch (e) {}
    return {};
}
function $5582cf41b70f685b$export$b007d77a962aa175(e, t = 0) {
    let s = $5582cf41b70f685b$export$26ddc56bc995240a(e);
    return !(Object.keys(s).length > 0 && (!s.exp || s.exp - t > Date.now() / 1e3));
}
$5582cf41b70f685b$var$s = "function" != typeof atob || $5582cf41b70f685b$var$t ? (e)=>{
    let t = String(e).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new Error("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var s, i, n = 0, r = 0, o = ""; i = t.charAt(r++); ~i && (s = n % 4 ? 64 * s + i : i, n++ % 4) && (o += String.fromCharCode(255 & s >> (-2 * n & 6))))i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(i);
    return o;
} : atob;
const $5582cf41b70f685b$var$i = "pb_auth";
class $5582cf41b70f685b$export$68a044b9d3f6e888 {
    constructor(){
        this.baseToken = "", this.baseModel = null, this._onChangeCallbacks = [];
    }
    get token() {
        return this.baseToken;
    }
    get model() {
        return this.baseModel;
    }
    get isValid() {
        return !$5582cf41b70f685b$export$b007d77a962aa175(this.token);
    }
    get isAdmin() {
        return "admin" === $5582cf41b70f685b$export$26ddc56bc995240a(this.token).type;
    }
    get isAuthRecord() {
        return "authRecord" === $5582cf41b70f685b$export$26ddc56bc995240a(this.token).type;
    }
    save(e, t) {
        this.baseToken = e || "", this.baseModel = t || null, this.triggerChange();
    }
    clear() {
        this.baseToken = "", this.baseModel = null, this.triggerChange();
    }
    loadFromCookie(e, t = $5582cf41b70f685b$var$i) {
        const s = $5582cf41b70f685b$export$2314e25186e9360(e || "")[t] || "";
        let n = {};
        try {
            n = JSON.parse(s), ("object" != typeof n || Array.isArray(n)) && (n = {});
        } catch (e) {}
        this.save(n.token || "", n.model || null);
    }
    exportToCookie(e, t = $5582cf41b70f685b$var$i) {
        const s = {
            secure: !0,
            sameSite: !0,
            httpOnly: !0,
            path: "/"
        }, n = $5582cf41b70f685b$export$26ddc56bc995240a(this.token);
        s.expires = n?.exp ? new Date(1e3 * n.exp) : new Date("1970-01-01"), e = Object.assign({}, s, e);
        const r = {
            token: this.token,
            model: this.model ? JSON.parse(JSON.stringify(this.model)) : null
        };
        let o = $5582cf41b70f685b$export$879d2f108927fb90(t, JSON.stringify(r), e);
        const a = "undefined" != typeof Blob ? new Blob([
            o
        ]).size : o.length;
        if (r.model && a > 4096) {
            r.model = {
                id: r?.model?.id,
                email: r?.model?.email
            };
            const s = [
                "collectionId",
                "username",
                "verified"
            ];
            for(const e in this.model)s.includes(e) && (r.model[e] = this.model[e]);
            o = $5582cf41b70f685b$export$879d2f108927fb90(t, JSON.stringify(r), e);
        }
        return o;
    }
    onChange(e, t = !1) {
        return this._onChangeCallbacks.push(e), t && e(this.token, this.model), ()=>{
            for(let t = this._onChangeCallbacks.length - 1; t >= 0; t--)if (this._onChangeCallbacks[t] == e) return delete this._onChangeCallbacks[t], void this._onChangeCallbacks.splice(t, 1);
        };
    }
    triggerChange() {
        for (const e of this._onChangeCallbacks)e && e(this.token, this.model);
    }
}
class $5582cf41b70f685b$export$6439a4b85bcd7f5d extends $5582cf41b70f685b$export$68a044b9d3f6e888 {
    constructor(e = "pocketbase_auth"){
        super(), this.storageFallback = {}, this.storageKey = e, this._bindStorageEvent();
    }
    get token() {
        return (this._storageGet(this.storageKey) || {}).token || "";
    }
    get model() {
        return (this._storageGet(this.storageKey) || {}).model || null;
    }
    save(e, t) {
        this._storageSet(this.storageKey, {
            token: e,
            model: t
        }), super.save(e, t);
    }
    clear() {
        this._storageRemove(this.storageKey), super.clear();
    }
    _storageGet(e) {
        if ("undefined" != typeof window && window?.localStorage) {
            const t = window.localStorage.getItem(e) || "";
            try {
                return JSON.parse(t);
            } catch (e) {
                return t;
            }
        }
        return this.storageFallback[e];
    }
    _storageSet(e, t) {
        if ("undefined" != typeof window && window?.localStorage) {
            let s = t;
            "string" != typeof t && (s = JSON.stringify(t)), window.localStorage.setItem(e, s);
        } else this.storageFallback[e] = t;
    }
    _storageRemove(e) {
        "undefined" != typeof window && window?.localStorage && window.localStorage?.removeItem(e), delete this.storageFallback[e];
    }
    _bindStorageEvent() {
        "undefined" != typeof window && window?.localStorage && window.addEventListener && window.addEventListener("storage", (e)=>{
            if (e.key != this.storageKey) return;
            const t = this._storageGet(this.storageKey) || {};
            super.save(t.token || "", t.model || null);
        });
    }
}
class $5582cf41b70f685b$var$BaseService {
    constructor(e){
        this.client = e;
    }
}
class $5582cf41b70f685b$var$SettingsService extends $5582cf41b70f685b$var$BaseService {
    async getAll(e) {
        return e = Object.assign({
            method: "GET"
        }, e), this.client.send("/api/settings", e);
    }
    async update(e, t) {
        return t = Object.assign({
            method: "PATCH",
            body: e
        }, t), this.client.send("/api/settings", t);
    }
    async testS3(e = "storage", t) {
        return t = Object.assign({
            method: "POST",
            body: {
                filesystem: e
            }
        }, t), this.client.send("/api/settings/test/s3", t).then(()=>!0);
    }
    async testEmail(e, t, s) {
        return s = Object.assign({
            method: "POST",
            body: {
                email: e,
                template: t
            }
        }, s), this.client.send("/api/settings/test/email", s).then(()=>!0);
    }
    async generateAppleClientSecret(e, t, s, i, n, r) {
        return r = Object.assign({
            method: "POST",
            body: {
                clientId: e,
                teamId: t,
                keyId: s,
                privateKey: i,
                duration: n
            }
        }, r), this.client.send("/api/settings/apple/generate-client-secret", r);
    }
}
class $5582cf41b70f685b$export$d8ebe4a1f8b281ca extends $5582cf41b70f685b$var$BaseService {
    decode(e) {
        return e;
    }
    async getFullList(e, t) {
        if ("number" == typeof e) return this._getFullList(e, t);
        let s = 500;
        return (t = Object.assign({}, e, t)).batch && (s = t.batch, delete t.batch), this._getFullList(s, t);
    }
    async getList(e = 1, t = 30, s) {
        return (s = Object.assign({
            method: "GET"
        }, s)).query = Object.assign({
            page: e,
            perPage: t
        }, s.query), this.client.send(this.baseCrudPath, s).then((e)=>(e.items = e.items?.map((e)=>this.decode(e)) || [], e));
    }
    async getFirstListItem(e, t) {
        return (t = Object.assign({
            requestKey: "one_by_filter_" + this.baseCrudPath + "_" + e
        }, t)).query = Object.assign({
            filter: e,
            skipTotal: 1
        }, t.query), this.getList(1, 1, t).then((e)=>{
            if (!e?.items?.length) throw new $5582cf41b70f685b$export$dcaf143e197b2cd2({
                status: 404,
                response: {
                    code: 404,
                    message: "The requested resource wasn't found.",
                    data: {}
                }
            });
            return e.items[0];
        });
    }
    async getOne(e, t) {
        if (!e) throw new $5582cf41b70f685b$export$dcaf143e197b2cd2({
            url: this.client.buildUrl(this.baseCrudPath + "/"),
            status: 404,
            response: {
                code: 404,
                message: "Missing required record id.",
                data: {}
            }
        });
        return t = Object.assign({
            method: "GET"
        }, t), this.client.send(this.baseCrudPath + "/" + encodeURIComponent(e), t).then((e)=>this.decode(e));
    }
    async create(e, t) {
        return t = Object.assign({
            method: "POST",
            body: e
        }, t), this.client.send(this.baseCrudPath, t).then((e)=>this.decode(e));
    }
    async update(e, t, s) {
        return s = Object.assign({
            method: "PATCH",
            body: t
        }, s), this.client.send(this.baseCrudPath + "/" + encodeURIComponent(e), s).then((e)=>this.decode(e));
    }
    async delete(e, t) {
        return t = Object.assign({
            method: "DELETE"
        }, t), this.client.send(this.baseCrudPath + "/" + encodeURIComponent(e), t).then(()=>!0);
    }
    _getFullList(e = 500, t) {
        (t = t || {}).query = Object.assign({
            skipTotal: 1
        }, t.query);
        let s = [], request = async (i)=>this.getList(i, e || 500, t).then((e)=>{
                const t = e.items;
                return s = s.concat(t), t.length == e.perPage ? request(i + 1) : s;
            });
        return request(1);
    }
}
function $5582cf41b70f685b$var$normalizeLegacyOptionsArgs(e, t, s, i) {
    const n = void 0 !== i;
    return n || void 0 !== s ? n ? (console.warn(e), t.body = Object.assign({}, t.body, s), t.query = Object.assign({}, t.query, i), t) : Object.assign(t, s) : t;
}
function $5582cf41b70f685b$var$resetAutoRefresh(e) {
    e._resetAutoRefresh?.();
}
class $5582cf41b70f685b$export$33af9b5749be502a extends $5582cf41b70f685b$export$d8ebe4a1f8b281ca {
    get baseCrudPath() {
        return "/api/admins";
    }
    async update(e, t, s) {
        return super.update(e, t, s).then((e)=>(this.client.authStore.model?.id === e.id && void 0 === this.client.authStore.model?.collectionId && this.client.authStore.save(this.client.authStore.token, e), e));
    }
    async delete(e, t) {
        return super.delete(e, t).then((t)=>(t && this.client.authStore.model?.id === e && void 0 === this.client.authStore.model?.collectionId && this.client.authStore.clear(), t));
    }
    authResponse(e) {
        const t = this.decode(e?.admin || {});
        return e?.token && e?.admin && this.client.authStore.save(e.token, t), Object.assign({}, e, {
            token: e?.token || "",
            admin: t
        });
    }
    async authWithPassword(e, t, s, i) {
        let n = {
            method: "POST",
            body: {
                identity: e,
                password: t
            }
        };
        n = $5582cf41b70f685b$var$normalizeLegacyOptionsArgs("This form of authWithPassword(email, pass, body?, query?) is deprecated. Consider replacing it with authWithPassword(email, pass, options?).", n, s, i);
        const r = n.autoRefreshThreshold;
        delete n.autoRefreshThreshold, n.autoRefresh || $5582cf41b70f685b$var$resetAutoRefresh(this.client);
        let o = await this.client.send(this.baseCrudPath + "/auth-with-password", n);
        return o = this.authResponse(o), r && function registerAutoRefresh(e, t, s, i) {
            $5582cf41b70f685b$var$resetAutoRefresh(e);
            const n = e.beforeSend, r = e.authStore.model, o = e.authStore.onChange((t, s)=>{
                (!t || s?.id != r?.id || (s?.collectionId || r?.collectionId) && s?.collectionId != r?.collectionId) && $5582cf41b70f685b$var$resetAutoRefresh(e);
            });
            e._resetAutoRefresh = function() {
                o(), e.beforeSend = n, delete e._resetAutoRefresh;
            }, e.beforeSend = async (r, o)=>{
                const a = e.authStore.token;
                if (o.query?.autoRefresh) return n ? n(r, o) : {
                    url: r,
                    sendOptions: o
                };
                let c = e.authStore.isValid;
                if (c && $5582cf41b70f685b$export$b007d77a962aa175(e.authStore.token, t)) try {
                    await s();
                } catch (e) {
                    c = !1;
                }
                c || await i();
                const l = o.headers || {};
                for(let t in l)if ("authorization" == t.toLowerCase() && a == l[t] && e.authStore.token) {
                    l[t] = e.authStore.token;
                    break;
                }
                return o.headers = l, n ? n(r, o) : {
                    url: r,
                    sendOptions: o
                };
            };
        }(this.client, r, ()=>this.authRefresh({
                autoRefresh: !0
            }), ()=>this.authWithPassword(e, t, Object.assign({
                autoRefresh: !0
            }, n))), o;
    }
    async authRefresh(e, t) {
        let s = {
            method: "POST"
        };
        return s = $5582cf41b70f685b$var$normalizeLegacyOptionsArgs("This form of authRefresh(body?, query?) is deprecated. Consider replacing it with authRefresh(options?).", s, e, t), this.client.send(this.baseCrudPath + "/auth-refresh", s).then(this.authResponse.bind(this));
    }
    async requestPasswordReset(e, t, s) {
        let i = {
            method: "POST",
            body: {
                email: e
            }
        };
        return i = $5582cf41b70f685b$var$normalizeLegacyOptionsArgs("This form of requestPasswordReset(email, body?, query?) is deprecated. Consider replacing it with requestPasswordReset(email, options?).", i, t, s), this.client.send(this.baseCrudPath + "/request-password-reset", i).then(()=>!0);
    }
    async confirmPasswordReset(e, t, s, i, n) {
        let r = {
            method: "POST",
            body: {
                token: e,
                password: t,
                passwordConfirm: s
            }
        };
        return r = $5582cf41b70f685b$var$normalizeLegacyOptionsArgs("This form of confirmPasswordReset(resetToken, password, passwordConfirm, body?, query?) is deprecated. Consider replacing it with confirmPasswordReset(resetToken, password, passwordConfirm, options?).", r, i, n), this.client.send(this.baseCrudPath + "/confirm-password-reset", r).then(()=>!0);
    }
}
const $5582cf41b70f685b$var$n = [
    "requestKey",
    "$cancelKey",
    "$autoCancel",
    "fetch",
    "headers",
    "body",
    "query",
    "params",
    "cache",
    "credentials",
    "headers",
    "integrity",
    "keepalive",
    "method",
    "mode",
    "redirect",
    "referrer",
    "referrerPolicy",
    "signal",
    "window"
];
function $5582cf41b70f685b$export$d4eab50bd87f5014(e) {
    if (e) {
        e.query = e.query || {};
        for(let t in e)$5582cf41b70f685b$var$n.includes(t) || (e.query[t] = e[t], delete e[t]);
    }
}
class $5582cf41b70f685b$export$94618cb2db738d0c extends $5582cf41b70f685b$var$BaseService {
    constructor(){
        super(...arguments), this.clientId = "", this.eventSource = null, this.subscriptions = {}, this.lastSentSubscriptions = [], this.maxConnectTimeout = 15e3, this.reconnectAttempts = 0, this.maxReconnectAttempts = 1 / 0, this.predefinedReconnectIntervals = [
            200,
            300,
            500,
            1e3,
            1200,
            1500,
            2e3
        ], this.pendingConnects = [];
    }
    get isConnected() {
        return !!this.eventSource && !!this.clientId && !this.pendingConnects.length;
    }
    async subscribe(e, t, s) {
        if (!e) throw new Error("topic must be set.");
        let i = e;
        if (s) {
            $5582cf41b70f685b$export$d4eab50bd87f5014(s = Object.assign({}, s));
            const e = "options=" + encodeURIComponent(JSON.stringify({
                query: s.query,
                headers: s.headers
            }));
            i += (i.includes("?") ? "&" : "?") + e;
        }
        const listener = function(e) {
            const s = e;
            let i;
            try {
                i = JSON.parse(s?.data);
            } catch  {}
            t(i || {});
        };
        return this.subscriptions[i] || (this.subscriptions[i] = []), this.subscriptions[i].push(listener), this.isConnected ? 1 === this.subscriptions[i].length ? await this.submitSubscriptions() : this.eventSource?.addEventListener(i, listener) : await this.connect(), async ()=>this.unsubscribeByTopicAndListener(e, listener);
    }
    async unsubscribe(e) {
        let t = !1;
        if (e) {
            const s = this.getSubscriptionsByTopic(e);
            for(let e in s)if (this.hasSubscriptionListeners(e)) {
                for (let t of this.subscriptions[e])this.eventSource?.removeEventListener(e, t);
                delete this.subscriptions[e], t || (t = !0);
            }
        } else this.subscriptions = {};
        this.hasSubscriptionListeners() ? t && await this.submitSubscriptions() : this.disconnect();
    }
    async unsubscribeByPrefix(e) {
        let t = !1;
        for(let s in this.subscriptions)if ((s + "?").startsWith(e)) {
            t = !0;
            for (let e of this.subscriptions[s])this.eventSource?.removeEventListener(s, e);
            delete this.subscriptions[s];
        }
        t && (this.hasSubscriptionListeners() ? await this.submitSubscriptions() : this.disconnect());
    }
    async unsubscribeByTopicAndListener(e, t) {
        let s = !1;
        const i = this.getSubscriptionsByTopic(e);
        for(let e in i){
            if (!Array.isArray(this.subscriptions[e]) || !this.subscriptions[e].length) continue;
            let i = !1;
            for(let s = this.subscriptions[e].length - 1; s >= 0; s--)this.subscriptions[e][s] === t && (i = !0, delete this.subscriptions[e][s], this.subscriptions[e].splice(s, 1), this.eventSource?.removeEventListener(e, t));
            i && (this.subscriptions[e].length || delete this.subscriptions[e], s || this.hasSubscriptionListeners(e) || (s = !0));
        }
        this.hasSubscriptionListeners() ? s && await this.submitSubscriptions() : this.disconnect();
    }
    hasSubscriptionListeners(e) {
        if (this.subscriptions = this.subscriptions || {}, e) return !!this.subscriptions[e]?.length;
        for(let e in this.subscriptions)if (this.subscriptions[e]?.length) return !0;
        return !1;
    }
    async submitSubscriptions() {
        if (this.clientId) return this.addAllSubscriptionListeners(), this.lastSentSubscriptions = this.getNonEmptySubscriptionKeys(), this.client.send("/api/realtime", {
            method: "POST",
            body: {
                clientId: this.clientId,
                subscriptions: this.lastSentSubscriptions
            },
            requestKey: this.getSubscriptionsCancelKey()
        }).catch((e)=>{
            if (!e?.isAbort) throw e;
        });
    }
    getSubscriptionsCancelKey() {
        return "realtime_" + this.clientId;
    }
    getSubscriptionsByTopic(e) {
        const t = {};
        e = e.includes("?") ? e : e + "?";
        for(let s in this.subscriptions)(s + "?").startsWith(e) && (t[s] = this.subscriptions[s]);
        return t;
    }
    getNonEmptySubscriptionKeys() {
        const e = [];
        for(let t in this.subscriptions)this.subscriptions[t].length && e.push(t);
        return e;
    }
    addAllSubscriptionListeners() {
        if (this.eventSource) {
            this.removeAllSubscriptionListeners();
            for(let e in this.subscriptions)for (let t of this.subscriptions[e])this.eventSource.addEventListener(e, t);
        }
    }
    removeAllSubscriptionListeners() {
        if (this.eventSource) for(let e in this.subscriptions)for (let t of this.subscriptions[e])this.eventSource.removeEventListener(e, t);
    }
    async connect() {
        if (!(this.reconnectAttempts > 0)) return new Promise((e, t)=>{
            this.pendingConnects.push({
                resolve: e,
                reject: t
            }), this.pendingConnects.length > 1 || this.initConnect();
        });
    }
    initConnect() {
        this.disconnect(!0), clearTimeout(this.connectTimeoutId), this.connectTimeoutId = setTimeout(()=>{
            this.connectErrorHandler(new Error("EventSource connect took too long."));
        }, this.maxConnectTimeout), this.eventSource = new EventSource(this.client.buildUrl("/api/realtime")), this.eventSource.onerror = (e)=>{
            this.connectErrorHandler(new Error("Failed to establish realtime connection."));
        }, this.eventSource.addEventListener("PB_CONNECT", (e)=>{
            const t = e;
            this.clientId = t?.lastEventId, this.submitSubscriptions().then(async ()=>{
                let e = 3;
                for(; this.hasUnsentSubscriptions() && e > 0;)e--, await this.submitSubscriptions();
            }).then(()=>{
                for (let e of this.pendingConnects)e.resolve();
                this.pendingConnects = [], this.reconnectAttempts = 0, clearTimeout(this.reconnectTimeoutId), clearTimeout(this.connectTimeoutId);
                const t = this.getSubscriptionsByTopic("PB_CONNECT");
                for(let s in t)for (let i of t[s])i(e);
            }).catch((e)=>{
                this.clientId = "", this.connectErrorHandler(e);
            });
        });
    }
    hasUnsentSubscriptions() {
        const e = this.getNonEmptySubscriptionKeys();
        if (e.length != this.lastSentSubscriptions.length) return !0;
        for (const t of e)if (!this.lastSentSubscriptions.includes(t)) return !0;
        return !1;
    }
    connectErrorHandler(e) {
        if (clearTimeout(this.connectTimeoutId), clearTimeout(this.reconnectTimeoutId), !this.clientId && !this.reconnectAttempts || this.reconnectAttempts > this.maxReconnectAttempts) {
            for (let t of this.pendingConnects)t.reject(new $5582cf41b70f685b$export$dcaf143e197b2cd2(e));
            return this.pendingConnects = [], void this.disconnect();
        }
        this.disconnect(!0);
        const t = this.predefinedReconnectIntervals[this.reconnectAttempts] || this.predefinedReconnectIntervals[this.predefinedReconnectIntervals.length - 1];
        this.reconnectAttempts++, this.reconnectTimeoutId = setTimeout(()=>{
            this.initConnect();
        }, t);
    }
    disconnect(e = !1) {
        if (clearTimeout(this.connectTimeoutId), clearTimeout(this.reconnectTimeoutId), this.removeAllSubscriptionListeners(), this.client.cancelRequest(this.getSubscriptionsCancelKey()), this.eventSource?.close(), this.eventSource = null, this.clientId = "", !e) {
            this.reconnectAttempts = 0;
            for (let e of this.pendingConnects)e.resolve();
            this.pendingConnects = [];
        }
    }
}
class $5582cf41b70f685b$export$1b7d28e1ebf40328 extends $5582cf41b70f685b$export$d8ebe4a1f8b281ca {
    constructor(e, t){
        super(e), this.collectionIdOrName = t;
    }
    get baseCrudPath() {
        return this.baseCollectionPath + "/records";
    }
    get baseCollectionPath() {
        return "/api/collections/" + encodeURIComponent(this.collectionIdOrName);
    }
    async subscribe(e, t, s) {
        if (!e) throw new Error("Missing topic.");
        if (!t) throw new Error("Missing subscription callback.");
        return this.client.realtime.subscribe(this.collectionIdOrName + "/" + e, t, s);
    }
    async unsubscribe(e) {
        return e ? this.client.realtime.unsubscribe(this.collectionIdOrName + "/" + e) : this.client.realtime.unsubscribeByPrefix(this.collectionIdOrName);
    }
    async getFullList(e, t) {
        if ("number" == typeof e) return super.getFullList(e, t);
        const s = Object.assign({}, e, t);
        return super.getFullList(s);
    }
    async getList(e = 1, t = 30, s) {
        return super.getList(e, t, s);
    }
    async getFirstListItem(e, t) {
        return super.getFirstListItem(e, t);
    }
    async getOne(e, t) {
        return super.getOne(e, t);
    }
    async create(e, t) {
        return super.create(e, t);
    }
    async update(e, t, s) {
        return super.update(e, t, s).then((e)=>(this.client.authStore.model?.id !== e?.id || this.client.authStore.model?.collectionId !== this.collectionIdOrName && this.client.authStore.model?.collectionName !== this.collectionIdOrName || this.client.authStore.save(this.client.authStore.token, e), e));
    }
    async delete(e, t) {
        return super.delete(e, t).then((t)=>(!t || this.client.authStore.model?.id !== e || this.client.authStore.model?.collectionId !== this.collectionIdOrName && this.client.authStore.model?.collectionName !== this.collectionIdOrName || this.client.authStore.clear(), t));
    }
    authResponse(e) {
        const t = this.decode(e?.record || {});
        return this.client.authStore.save(e?.token, t), Object.assign({}, e, {
            token: e?.token || "",
            record: t
        });
    }
    async listAuthMethods(e) {
        return e = Object.assign({
            method: "GET"
        }, e), this.client.send(this.baseCollectionPath + "/auth-methods", e).then((e)=>Object.assign({}, e, {
                usernamePassword: !!e?.usernamePassword,
                emailPassword: !!e?.emailPassword,
                authProviders: Array.isArray(e?.authProviders) ? e?.authProviders : []
            }));
    }
    async authWithPassword(e, t, s, i) {
        let n = {
            method: "POST",
            body: {
                identity: e,
                password: t
            }
        };
        return n = $5582cf41b70f685b$var$normalizeLegacyOptionsArgs("This form of authWithPassword(usernameOrEmail, pass, body?, query?) is deprecated. Consider replacing it with authWithPassword(usernameOrEmail, pass, options?).", n, s, i), this.client.send(this.baseCollectionPath + "/auth-with-password", n).then((e)=>this.authResponse(e));
    }
    async authWithOAuth2Code(e, t, s, i, n, r, o) {
        let a = {
            method: "POST",
            body: {
                provider: e,
                code: t,
                codeVerifier: s,
                redirectUrl: i,
                createData: n
            }
        };
        return a = $5582cf41b70f685b$var$normalizeLegacyOptionsArgs("This form of authWithOAuth2Code(provider, code, codeVerifier, redirectUrl, createData?, body?, query?) is deprecated. Consider replacing it with authWithOAuth2Code(provider, code, codeVerifier, redirectUrl, createData?, options?).", a, r, o), this.client.send(this.baseCollectionPath + "/auth-with-oauth2", a).then((e)=>this.authResponse(e));
    }
    authWithOAuth2(...e) {
        if (e.length > 1 || "string" == typeof e?.[0]) return console.warn("PocketBase: This form of authWithOAuth2() is deprecated and may get removed in the future. Please replace with authWithOAuth2Code() OR use the authWithOAuth2() realtime form as shown in https://pocketbase.io/docs/authentication/#oauth2-integration."), this.authWithOAuth2Code(e?.[0] || "", e?.[1] || "", e?.[2] || "", e?.[3] || "", e?.[4] || {}, e?.[5] || {}, e?.[6] || {});
        const t = e?.[0] || {};
        let s = null;
        t.urlCallback || (s = $5582cf41b70f685b$var$openBrowserPopup(void 0));
        const i = new $5582cf41b70f685b$export$94618cb2db738d0c(this.client);
        function cleanup() {
            s?.close(), i.unsubscribe();
        }
        const n = {}, r = t.requestKey;
        return r && (n.requestKey = r), this.listAuthMethods(n).then((e)=>{
            const n = e.authProviders.find((e)=>e.name === t.provider);
            if (!n) throw new $5582cf41b70f685b$export$dcaf143e197b2cd2(new Error(`Missing or invalid provider "${t.provider}".`));
            const o = this.client.buildUrl("/api/oauth2-redirect"), a = r ? this.client.cancelControllers?.[r] : void 0;
            return a && (a.signal.onabort = ()=>{
                cleanup();
            }), new Promise(async (e, r)=>{
                try {
                    await i.subscribe("@oauth2", async (s)=>{
                        const c = i.clientId;
                        try {
                            if (!s.state || c !== s.state) throw new Error("State parameters don't match.");
                            if (s.error || !s.code) throw new Error("OAuth2 redirect error or missing code: " + s.error);
                            const i = Object.assign({}, t);
                            delete i.provider, delete i.scopes, delete i.createData, delete i.urlCallback, a?.signal?.onabort && (a.signal.onabort = null);
                            const r = await this.authWithOAuth2Code(n.name, s.code, n.codeVerifier, o, t.createData, i);
                            e(r);
                        } catch (e) {
                            r(new $5582cf41b70f685b$export$dcaf143e197b2cd2(e));
                        }
                        cleanup();
                    });
                    const c = {
                        state: i.clientId
                    };
                    t.scopes?.length && (c.scope = t.scopes.join(" "));
                    const l = this._replaceQueryParams(n.authUrl + o, c);
                    let h = t.urlCallback || function(e) {
                        s ? s.location.href = e : s = $5582cf41b70f685b$var$openBrowserPopup(e);
                    };
                    await h(l);
                } catch (e) {
                    cleanup(), r(new $5582cf41b70f685b$export$dcaf143e197b2cd2(e));
                }
            });
        }).catch((e)=>{
            throw cleanup(), e;
        });
    }
    async authRefresh(e, t) {
        let s = {
            method: "POST"
        };
        return s = $5582cf41b70f685b$var$normalizeLegacyOptionsArgs("This form of authRefresh(body?, query?) is deprecated. Consider replacing it with authRefresh(options?).", s, e, t), this.client.send(this.baseCollectionPath + "/auth-refresh", s).then((e)=>this.authResponse(e));
    }
    async requestPasswordReset(e, t, s) {
        let i = {
            method: "POST",
            body: {
                email: e
            }
        };
        return i = $5582cf41b70f685b$var$normalizeLegacyOptionsArgs("This form of requestPasswordReset(email, body?, query?) is deprecated. Consider replacing it with requestPasswordReset(email, options?).", i, t, s), this.client.send(this.baseCollectionPath + "/request-password-reset", i).then(()=>!0);
    }
    async confirmPasswordReset(e, t, s, i, n) {
        let r = {
            method: "POST",
            body: {
                token: e,
                password: t,
                passwordConfirm: s
            }
        };
        return r = $5582cf41b70f685b$var$normalizeLegacyOptionsArgs("This form of confirmPasswordReset(token, password, passwordConfirm, body?, query?) is deprecated. Consider replacing it with confirmPasswordReset(token, password, passwordConfirm, options?).", r, i, n), this.client.send(this.baseCollectionPath + "/confirm-password-reset", r).then(()=>!0);
    }
    async requestVerification(e, t, s) {
        let i = {
            method: "POST",
            body: {
                email: e
            }
        };
        return i = $5582cf41b70f685b$var$normalizeLegacyOptionsArgs("This form of requestVerification(email, body?, query?) is deprecated. Consider replacing it with requestVerification(email, options?).", i, t, s), this.client.send(this.baseCollectionPath + "/request-verification", i).then(()=>!0);
    }
    async confirmVerification(e, t, s) {
        let i = {
            method: "POST",
            body: {
                token: e
            }
        };
        return i = $5582cf41b70f685b$var$normalizeLegacyOptionsArgs("This form of confirmVerification(token, body?, query?) is deprecated. Consider replacing it with confirmVerification(token, options?).", i, t, s), this.client.send(this.baseCollectionPath + "/confirm-verification", i).then(()=>{
            const t = $5582cf41b70f685b$export$26ddc56bc995240a(e), s = this.client.authStore.model;
            return s && !s.verified && s.id === t.id && s.collectionId === t.collectionId && (s.verified = !0, this.client.authStore.save(this.client.authStore.token, s)), !0;
        });
    }
    async requestEmailChange(e, t, s) {
        let i = {
            method: "POST",
            body: {
                newEmail: e
            }
        };
        return i = $5582cf41b70f685b$var$normalizeLegacyOptionsArgs("This form of requestEmailChange(newEmail, body?, query?) is deprecated. Consider replacing it with requestEmailChange(newEmail, options?).", i, t, s), this.client.send(this.baseCollectionPath + "/request-email-change", i).then(()=>!0);
    }
    async confirmEmailChange(e, t, s, i) {
        let n = {
            method: "POST",
            body: {
                token: e,
                password: t
            }
        };
        return n = $5582cf41b70f685b$var$normalizeLegacyOptionsArgs("This form of confirmEmailChange(token, password, body?, query?) is deprecated. Consider replacing it with confirmEmailChange(token, password, options?).", n, s, i), this.client.send(this.baseCollectionPath + "/confirm-email-change", n).then(()=>{
            const t = $5582cf41b70f685b$export$26ddc56bc995240a(e), s = this.client.authStore.model;
            return s && s.id === t.id && s.collectionId === t.collectionId && this.client.authStore.clear(), !0;
        });
    }
    async listExternalAuths(e, t) {
        return t = Object.assign({
            method: "GET"
        }, t), this.client.send(this.baseCrudPath + "/" + encodeURIComponent(e) + "/external-auths", t);
    }
    async unlinkExternalAuth(e, t, s) {
        return s = Object.assign({
            method: "DELETE"
        }, s), this.client.send(this.baseCrudPath + "/" + encodeURIComponent(e) + "/external-auths/" + encodeURIComponent(t), s).then(()=>!0);
    }
    _replaceQueryParams(e, t = {}) {
        let s = e, i = "";
        e.indexOf("?") >= 0 && (s = e.substring(0, e.indexOf("?")), i = e.substring(e.indexOf("?") + 1));
        const n = {}, r = i.split("&");
        for (const e of r){
            if ("" == e) continue;
            const t = e.split("=");
            n[decodeURIComponent(t[0].replace(/\+/g, " "))] = decodeURIComponent((t[1] || "").replace(/\+/g, " "));
        }
        for(let e in t)t.hasOwnProperty(e) && (null == t[e] ? delete n[e] : n[e] = t[e]);
        i = "";
        for(let e in n)n.hasOwnProperty(e) && ("" != i && (i += "&"), i += encodeURIComponent(e.replace(/%20/g, "+")) + "=" + encodeURIComponent(n[e].replace(/%20/g, "+")));
        return "" != i ? s + "?" + i : s;
    }
}
function $5582cf41b70f685b$var$openBrowserPopup(e) {
    if ("undefined" == typeof window || !window?.open) throw new $5582cf41b70f685b$export$dcaf143e197b2cd2(new Error("Not in a browser context - please pass a custom urlCallback function."));
    let t = 1024, s = 768, i = window.innerWidth, n = window.innerHeight;
    t = t > i ? i : t, s = s > n ? n : s;
    let r = i / 2 - t / 2, o = n / 2 - s / 2;
    return window.open(e, "popup_window", "width=" + t + ",height=" + s + ",top=" + o + ",left=" + r + ",resizable,menubar=no");
}
class $5582cf41b70f685b$export$133889e600929275 extends $5582cf41b70f685b$export$d8ebe4a1f8b281ca {
    get baseCrudPath() {
        return "/api/collections";
    }
    async import(e, t = !1, s) {
        return s = Object.assign({
            method: "PUT",
            body: {
                collections: e,
                deleteMissing: t
            }
        }, s), this.client.send(this.baseCrudPath + "/import", s).then(()=>!0);
    }
}
class $5582cf41b70f685b$export$e2c5c1c0df6e287f extends $5582cf41b70f685b$var$BaseService {
    async getList(e = 1, t = 30, s) {
        return (s = Object.assign({
            method: "GET"
        }, s)).query = Object.assign({
            page: e,
            perPage: t
        }, s.query), this.client.send("/api/logs", s);
    }
    async getOne(e, t) {
        if (!e) throw new $5582cf41b70f685b$export$dcaf143e197b2cd2({
            url: this.client.buildUrl("/api/logs/"),
            status: 404,
            response: {
                code: 404,
                message: "Missing required log id.",
                data: {}
            }
        });
        return t = Object.assign({
            method: "GET"
        }, t), this.client.send("/api/logs/" + encodeURIComponent(e), t);
    }
    async getStats(e) {
        return e = Object.assign({
            method: "GET"
        }, e), this.client.send("/api/logs/stats", e);
    }
}
class $5582cf41b70f685b$export$4fba2293eb4aeaad extends $5582cf41b70f685b$var$BaseService {
    async check(e) {
        return e = Object.assign({
            method: "GET"
        }, e), this.client.send("/api/health", e);
    }
}
class $5582cf41b70f685b$var$FileService extends $5582cf41b70f685b$var$BaseService {
    getUrl(e, t, s = {}) {
        if (!t || !e?.id || !e?.collectionId && !e?.collectionName) return "";
        const i = [];
        i.push("api"), i.push("files"), i.push(encodeURIComponent(e.collectionId || e.collectionName)), i.push(encodeURIComponent(e.id)), i.push(encodeURIComponent(t));
        let n = this.client.buildUrl(i.join("/"));
        if (Object.keys(s).length) {
            !1 === s.download && delete s.download;
            const e = new URLSearchParams(s);
            n += (n.includes("?") ? "&" : "?") + e;
        }
        return n;
    }
    async getToken(e) {
        return e = Object.assign({
            method: "POST"
        }, e), this.client.send("/api/files/token", e).then((e)=>e?.token || "");
    }
}
class $5582cf41b70f685b$var$BackupService extends $5582cf41b70f685b$var$BaseService {
    async getFullList(e) {
        return e = Object.assign({
            method: "GET"
        }, e), this.client.send("/api/backups", e);
    }
    async create(e, t) {
        return t = Object.assign({
            method: "POST",
            body: {
                name: e
            }
        }, t), this.client.send("/api/backups", t).then(()=>!0);
    }
    async upload(e, t) {
        return t = Object.assign({
            method: "POST",
            body: e
        }, t), this.client.send("/api/backups/upload", t).then(()=>!0);
    }
    async delete(e, t) {
        return t = Object.assign({
            method: "DELETE"
        }, t), this.client.send(`/api/backups/${encodeURIComponent(e)}`, t).then(()=>!0);
    }
    async restore(e, t) {
        return t = Object.assign({
            method: "POST"
        }, t), this.client.send(`/api/backups/${encodeURIComponent(e)}/restore`, t).then(()=>!0);
    }
    getDownloadUrl(e, t) {
        return this.client.buildUrl(`/api/backups/${encodeURIComponent(t)}?token=${encodeURIComponent(e)}`);
    }
}
class $5582cf41b70f685b$export$2e2bcd8739ae039 {
    constructor(e = "/", t, s = "en-US"){
        this.cancelControllers = {}, this.recordServices = {}, this.enableAutoCancellation = !0, this.baseUrl = e, this.lang = s, this.authStore = t || new $5582cf41b70f685b$export$6439a4b85bcd7f5d, this.admins = new $5582cf41b70f685b$export$33af9b5749be502a(this), this.collections = new $5582cf41b70f685b$export$133889e600929275(this), this.files = new $5582cf41b70f685b$var$FileService(this), this.logs = new $5582cf41b70f685b$export$e2c5c1c0df6e287f(this), this.settings = new $5582cf41b70f685b$var$SettingsService(this), this.realtime = new $5582cf41b70f685b$export$94618cb2db738d0c(this), this.health = new $5582cf41b70f685b$export$4fba2293eb4aeaad(this), this.backups = new $5582cf41b70f685b$var$BackupService(this);
    }
    collection(e) {
        return this.recordServices[e] || (this.recordServices[e] = new $5582cf41b70f685b$export$1b7d28e1ebf40328(this, e)), this.recordServices[e];
    }
    autoCancellation(e) {
        return this.enableAutoCancellation = !!e, this;
    }
    cancelRequest(e) {
        return this.cancelControllers[e] && (this.cancelControllers[e].abort(), delete this.cancelControllers[e]), this;
    }
    cancelAllRequests() {
        for(let e in this.cancelControllers)this.cancelControllers[e].abort();
        return this.cancelControllers = {}, this;
    }
    filter(e, t) {
        if (!t) return e;
        for(let s in t){
            let i = t[s];
            switch(typeof i){
                case "boolean":
                case "number":
                    i = "" + i;
                    break;
                case "string":
                    i = "'" + i.replace(/'/g, "\\'") + "'";
                    break;
                default:
                    i = null === i ? "null" : i instanceof Date ? "'" + i.toISOString().replace("T", " ") + "'" : "'" + JSON.stringify(i).replace(/'/g, "\\'") + "'";
            }
            e = e.replaceAll("{:" + s + "}", i);
        }
        return e;
    }
    getFileUrl(e, t, s = {}) {
        return this.files.getUrl(e, t, s);
    }
    buildUrl(e) {
        let t = this.baseUrl;
        return "undefined" == typeof window || !window.location || t.startsWith("https://") || t.startsWith("http://") || (t = window.location.origin?.endsWith("/") ? window.location.origin.substring(0, window.location.origin.length - 1) : window.location.origin || "", this.baseUrl.startsWith("/") || (t += window.location.pathname || "/", t += t.endsWith("/") ? "" : "/"), t += this.baseUrl), e && (t += t.endsWith("/") ? "" : "/", t += e.startsWith("/") ? e.substring(1) : e), t;
    }
    async send(e, t) {
        t = this.initSendOptions(e, t);
        let s = this.buildUrl(e);
        if (this.beforeSend) {
            const e = Object.assign({}, await this.beforeSend(s, t));
            void 0 !== e.url || void 0 !== e.options ? (s = e.url || s, t = e.options || t) : Object.keys(e).length && (t = e, console?.warn && console.warn("Deprecated format of beforeSend return: please use `return { url, options }`, instead of `return options`."));
        }
        if (void 0 !== t.query) {
            const e = this.serializeQueryParams(t.query);
            e && (s += (s.includes("?") ? "&" : "?") + e), delete t.query;
        }
        "application/json" == this.getHeader(t.headers, "Content-Type") && t.body && "string" != typeof t.body && (t.body = JSON.stringify(t.body));
        return (t.fetch || fetch)(s, t).then(async (e)=>{
            let t = {};
            try {
                t = await e.json();
            } catch (e) {}
            if (this.afterSend && (t = await this.afterSend(e, t)), e.status >= 400) throw new $5582cf41b70f685b$export$dcaf143e197b2cd2({
                url: e.url,
                status: e.status,
                data: t
            });
            return t;
        }).catch((e)=>{
            throw new $5582cf41b70f685b$export$dcaf143e197b2cd2(e);
        });
    }
    initSendOptions(e, t) {
        if ((t = Object.assign({
            method: "GET"
        }, t)).body = this.convertToFormDataIfNeeded(t.body), $5582cf41b70f685b$export$d4eab50bd87f5014(t), t.query = Object.assign({}, t.params, t.query), void 0 === t.requestKey && (!1 === t.$autoCancel || !1 === t.query.$autoCancel ? t.requestKey = null : (t.$cancelKey || t.query.$cancelKey) && (t.requestKey = t.$cancelKey || t.query.$cancelKey)), delete t.$autoCancel, delete t.query.$autoCancel, delete t.$cancelKey, delete t.query.$cancelKey, null !== this.getHeader(t.headers, "Content-Type") || this.isFormData(t.body) || (t.headers = Object.assign({}, t.headers, {
            "Content-Type": "application/json"
        })), null === this.getHeader(t.headers, "Accept-Language") && (t.headers = Object.assign({}, t.headers, {
            "Accept-Language": this.lang
        })), this.authStore.token && null === this.getHeader(t.headers, "Authorization") && (t.headers = Object.assign({}, t.headers, {
            Authorization: this.authStore.token
        })), this.enableAutoCancellation && null !== t.requestKey) {
            const s = t.requestKey || (t.method || "GET") + e;
            delete t.requestKey, this.cancelRequest(s);
            const i = new AbortController;
            this.cancelControllers[s] = i, t.signal = i.signal;
        }
        return t;
    }
    convertToFormDataIfNeeded(e) {
        if ("undefined" == typeof FormData || void 0 === e || "object" != typeof e || null === e || this.isFormData(e) || !this.hasBlobField(e)) return e;
        const t = new FormData;
        for(const s in e){
            const i = e[s];
            if ("object" != typeof i || this.hasBlobField({
                data: i
            })) {
                const e = Array.isArray(i) ? i : [
                    i
                ];
                for (let i of e)t.append(s, i);
            } else {
                let e = {};
                e[s] = i, t.append("@jsonPayload", JSON.stringify(e));
            }
        }
        return t;
    }
    hasBlobField(e) {
        for(const t in e){
            const s = Array.isArray(e[t]) ? e[t] : [
                e[t]
            ];
            for (const e of s)if ("undefined" != typeof Blob && e instanceof Blob || "undefined" != typeof File && e instanceof File) return !0;
        }
        return !1;
    }
    getHeader(e, t) {
        e = e || {}, t = t.toLowerCase();
        for(let s in e)if (s.toLowerCase() == t) return e[s];
        return null;
    }
    isFormData(e) {
        return e && ("FormData" === e.constructor.name || "undefined" != typeof FormData && e instanceof FormData);
    }
    serializeQueryParams(e) {
        const t = [];
        for(const s in e){
            if (null === e[s]) continue;
            const i = e[s], n = encodeURIComponent(s);
            if (Array.isArray(i)) for (const e of i)t.push(n + "=" + encodeURIComponent(e));
            else i instanceof Date ? t.push(n + "=" + encodeURIComponent(i.toISOString())) : "object" == typeof i ? t.push(n + "=" + encodeURIComponent(JSON.stringify(i))) : t.push(n + "=" + encodeURIComponent(i));
        }
        return t.join("&");
    }
}
class $5582cf41b70f685b$export$c94662ed41386ffd extends $5582cf41b70f685b$export$68a044b9d3f6e888 {
    constructor(e){
        super(), this.queue = [], this.saveFunc = e.save, this.clearFunc = e.clear, this._enqueue(()=>this._loadInitial(e.initial));
    }
    save(e, t) {
        super.save(e, t);
        let s = "";
        try {
            s = JSON.stringify({
                token: e,
                model: t
            });
        } catch (e) {
            console.warn("AsyncAuthStore: failed to stringify the new state");
        }
        this._enqueue(()=>this.saveFunc(s));
    }
    clear() {
        super.clear(), this.clearFunc ? this._enqueue(()=>this.clearFunc()) : this._enqueue(()=>this.saveFunc(""));
    }
    async _loadInitial(e) {
        try {
            if (e = await e) {
                let t;
                "string" == typeof e ? t = JSON.parse(e) || {} : "object" == typeof e && (t = e), this.save(t.token || "", t.model || null);
            }
        } catch (e) {}
    }
    _enqueue(e) {
        this.queue.push(e), 1 == this.queue.length && this._dequeue();
    }
    _dequeue() {
        this.queue.length && this.queue[0]().finally(()=>{
            this.queue.shift(), this.queue.length && this._dequeue();
        });
    }
}

});

parcelRegister("g8FP8", function(module, exports) {

$parcel$export(module.exports, "init", () => $df612559f80b0bc7$export$2cd8252107eb640b);
$parcel$export(module.exports, "success", () => $df612559f80b0bc7$export$fe7c49d056ea1d88);
$parcel$export(module.exports, "warning", () => $df612559f80b0bc7$export$491112666e282270);
$parcel$export(module.exports, "info", () => $df612559f80b0bc7$export$a80b3bd66acc52ff);
$parcel$export(module.exports, "error", () => $df612559f80b0bc7$export$a3bc9b8ed74fc);
$parcel$export(module.exports, "reportError", () => $df612559f80b0bc7$export$b33b857ad1d9900e);

var $j8Uso = parcelRequire("j8Uso");

var $1LIL3 = parcelRequire("1LIL3");
/**
 * Helper functions for universal pop-ups and error logging
 */ let $df612559f80b0bc7$var$notyf;
const $df612559f80b0bc7$var$UNIDENTIFIED_ERROR_MESSAGE = "Unidentified error! See the logs for more info";
// Having a seperate init function allows this only to be called once in the whole codebase,
// whilst still allowing other files to import and use the success, warning... functions
function $df612559f80b0bc7$export$2cd8252107eb640b() {
    $df612559f80b0bc7$var$notyf = new (0, $j8Uso.Notyf)({
        position: {
            x: "center",
            y: "top"
        },
        duration: 5000,
        dismissible: true,
        types: [
            {
                type: "error",
                ripple: false
            },
            {
                type: "success",
                ripple: true
            },
            {
                type: "warning",
                ripple: false,
                className: "black-text",
                background: "#FFEA53"
            },
            {
                type: "info",
                ripple: true,
                background: "#0505FF"
            }
        ]
    });
}
function $df612559f80b0bc7$export$fe7c49d056ea1d88(msg) {
    return $df612559f80b0bc7$var$notyf.success(msg);
}
function $df612559f80b0bc7$export$491112666e282270(msg) {
    return $df612559f80b0bc7$var$notyf.open({
        type: "warning",
        message: msg
    });
}
function $df612559f80b0bc7$export$a80b3bd66acc52ff(msg) {
    return $df612559f80b0bc7$var$notyf.open({
        type: "info",
        message: msg
    });
}
function $df612559f80b0bc7$export$a3bc9b8ed74fc(msg) {
    return $df612559f80b0bc7$var$notyf.error(msg);
}
function $df612559f80b0bc7$var$_unidentifiedError(err) {
    // The Pocketbase errors embed weirdly in console. For full info, log a stringify
    console.log(JSON.stringify(err));
    return $df612559f80b0bc7$var$UNIDENTIFIED_ERROR_MESSAGE;
}
function $df612559f80b0bc7$export$b33b857ad1d9900e(label, err) {
    let message = "";
    if (err instanceof (0, $1LIL3.ClientResponseError)) {
        const errData = err.response.data;
        const errDataKeys = Object.keys(errData);
        if (errDataKeys.length < 0) errDataKeys.forEach((key)=>{
            switch(key){
                case "passwordConfirm":
                    message = "PIN codes do not match!";
                    break;
                default:
                    message = $df612559f80b0bc7$var$_unidentifiedError(err);
                    break;
            }
        });
        else message = err.message;
    } else message = $df612559f80b0bc7$var$_unidentifiedError(err);
    $df612559f80b0bc7$export$a3bc9b8ed74fc(label + ": " + message);
}

});
parcelRegister("j8Uso", function(module, exports) {

$parcel$export(module.exports, "NotyfEvent", () => $defa8edbc79437a8$export$776308576d349339);
$parcel$export(module.exports, "Notyf", () => $defa8edbc79437a8$export$146ebdf5fc143718);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $defa8edbc79437a8$var$__assign = function() {
    $defa8edbc79437a8$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $defa8edbc79437a8$var$__assign.apply(this, arguments);
};
var $defa8edbc79437a8$export$1efaef7de3802058 = /** @class */ function() {
    function NotyfNotification(options) {
        this.options = options;
        this.listeners = {};
    }
    NotyfNotification.prototype.on = function(eventType, cb) {
        var callbacks = this.listeners[eventType] || [];
        this.listeners[eventType] = callbacks.concat([
            cb
        ]);
    };
    NotyfNotification.prototype.triggerEvent = function(eventType, event) {
        var _this = this;
        var callbacks = this.listeners[eventType] || [];
        callbacks.forEach(function(cb) {
            return cb({
                target: _this,
                event: event
            });
        });
    };
    return NotyfNotification;
}();
var $defa8edbc79437a8$export$2324fc501d2ffc65;
(function(NotyfArrayEvent) {
    NotyfArrayEvent[NotyfArrayEvent["Add"] = 0] = "Add";
    NotyfArrayEvent[NotyfArrayEvent["Remove"] = 1] = "Remove";
})($defa8edbc79437a8$export$2324fc501d2ffc65 || ($defa8edbc79437a8$export$2324fc501d2ffc65 = {}));
var $defa8edbc79437a8$export$7763ebb8bf460cea = /** @class */ function() {
    function NotyfArray() {
        this.notifications = [];
    }
    NotyfArray.prototype.push = function(elem) {
        this.notifications.push(elem);
        this.updateFn(elem, $defa8edbc79437a8$export$2324fc501d2ffc65.Add, this.notifications);
    };
    NotyfArray.prototype.splice = function(index, num) {
        var elem = this.notifications.splice(index, num)[0];
        this.updateFn(elem, $defa8edbc79437a8$export$2324fc501d2ffc65.Remove, this.notifications);
        return elem;
    };
    NotyfArray.prototype.indexOf = function(elem) {
        return this.notifications.indexOf(elem);
    };
    NotyfArray.prototype.onUpdate = function(fn) {
        this.updateFn = fn;
    };
    return NotyfArray;
}();
var $defa8edbc79437a8$export$776308576d349339;
(function(NotyfEvent) {
    NotyfEvent["Dismiss"] = "dismiss";
    NotyfEvent["Click"] = "click";
})($defa8edbc79437a8$export$776308576d349339 || ($defa8edbc79437a8$export$776308576d349339 = {}));
var $defa8edbc79437a8$export$93ca5d3f8675ae4c = {
    types: [
        {
            type: "success",
            className: "notyf__toast--success",
            backgroundColor: "#3dc763",
            icon: {
                className: "notyf__icon--success",
                tagName: "i"
            }
        },
        {
            type: "error",
            className: "notyf__toast--error",
            backgroundColor: "#ed3d3d",
            icon: {
                className: "notyf__icon--error",
                tagName: "i"
            }
        }
    ],
    duration: 2000,
    ripple: true,
    position: {
        x: "right",
        y: "bottom"
    },
    dismissible: false
};
var $defa8edbc79437a8$export$75d30b0f81ca0e5f = /** @class */ function() {
    function NotyfView() {
        this.notifications = [];
        this.events = {};
        this.X_POSITION_FLEX_MAP = {
            left: "flex-start",
            center: "center",
            right: "flex-end"
        };
        this.Y_POSITION_FLEX_MAP = {
            top: "flex-start",
            center: "center",
            bottom: "flex-end"
        };
        // Creates the main notifications container
        var docFrag = document.createDocumentFragment();
        var notyfContainer = this._createHTMLElement({
            tagName: "div",
            className: "notyf"
        });
        docFrag.appendChild(notyfContainer);
        document.body.appendChild(docFrag);
        this.container = notyfContainer;
        // Identifies the main animation end event
        this.animationEndEventName = this._getAnimationEndEventName();
        this._createA11yContainer();
    }
    NotyfView.prototype.on = function(event, cb) {
        var _a;
        this.events = $defa8edbc79437a8$var$__assign($defa8edbc79437a8$var$__assign({}, this.events), (_a = {}, _a[event] = cb, _a));
    };
    NotyfView.prototype.update = function(notification, type) {
        if (type === $defa8edbc79437a8$export$2324fc501d2ffc65.Add) this.addNotification(notification);
        else if (type === $defa8edbc79437a8$export$2324fc501d2ffc65.Remove) this.removeNotification(notification);
    };
    NotyfView.prototype.removeNotification = function(notification) {
        var _this = this;
        var renderedNotification = this._popRenderedNotification(notification);
        var node;
        if (!renderedNotification) return;
        node = renderedNotification.node;
        node.classList.add("notyf__toast--disappear");
        var handleEvent;
        node.addEventListener(this.animationEndEventName, handleEvent = function(event) {
            if (event.target === node) {
                node.removeEventListener(_this.animationEndEventName, handleEvent);
                _this.container.removeChild(node);
            }
        });
    };
    NotyfView.prototype.addNotification = function(notification) {
        var node = this._renderNotification(notification);
        this.notifications.push({
            notification: notification,
            node: node
        });
        // For a11y purposes, we still want to announce that there's a notification in the screen
        // even if it comes with no message.
        this._announce(notification.options.message || "Notification");
    };
    NotyfView.prototype._renderNotification = function(notification) {
        var _a;
        var card = this._buildNotificationCard(notification);
        var className = notification.options.className;
        if (className) (_a = card.classList).add.apply(_a, className.split(" "));
        this.container.appendChild(card);
        return card;
    };
    NotyfView.prototype._popRenderedNotification = function(notification) {
        var idx = -1;
        for(var i = 0; i < this.notifications.length && idx < 0; i++)if (this.notifications[i].notification === notification) idx = i;
        if (idx !== -1) return this.notifications.splice(idx, 1)[0];
        return;
    };
    NotyfView.prototype.getXPosition = function(options) {
        var _a;
        return ((_a = options === null || options === void 0 ? void 0 : options.position) === null || _a === void 0 ? void 0 : _a.x) || "right";
    };
    NotyfView.prototype.getYPosition = function(options) {
        var _a;
        return ((_a = options === null || options === void 0 ? void 0 : options.position) === null || _a === void 0 ? void 0 : _a.y) || "bottom";
    };
    NotyfView.prototype.adjustContainerAlignment = function(options) {
        var align = this.X_POSITION_FLEX_MAP[this.getXPosition(options)];
        var justify = this.Y_POSITION_FLEX_MAP[this.getYPosition(options)];
        var style = this.container.style;
        style.setProperty("justify-content", justify);
        style.setProperty("align-items", align);
    };
    NotyfView.prototype._buildNotificationCard = function(notification) {
        var _this = this;
        var options = notification.options;
        var iconOpts = options.icon;
        // Adjust container according to position (e.g. top-left, bottom-center, etc)
        this.adjustContainerAlignment(options);
        // Create elements
        var notificationElem = this._createHTMLElement({
            tagName: "div",
            className: "notyf__toast"
        });
        var ripple = this._createHTMLElement({
            tagName: "div",
            className: "notyf__ripple"
        });
        var wrapper = this._createHTMLElement({
            tagName: "div",
            className: "notyf__wrapper"
        });
        var message = this._createHTMLElement({
            tagName: "div",
            className: "notyf__message"
        });
        message.innerHTML = options.message || "";
        var mainColor = options.background || options.backgroundColor;
        // Build the icon and append it to the card
        if (iconOpts) {
            var iconContainer = this._createHTMLElement({
                tagName: "div",
                className: "notyf__icon"
            });
            if (typeof iconOpts === "string" || iconOpts instanceof String) iconContainer.innerHTML = new String(iconOpts).valueOf();
            if (typeof iconOpts === "object") {
                var _a = iconOpts.tagName, tagName = _a === void 0 ? "i" : _a, className_1 = iconOpts.className, text = iconOpts.text, _b = iconOpts.color, color = _b === void 0 ? mainColor : _b;
                var iconElement = this._createHTMLElement({
                    tagName: tagName,
                    className: className_1,
                    text: text
                });
                if (color) iconElement.style.color = color;
                iconContainer.appendChild(iconElement);
            }
            wrapper.appendChild(iconContainer);
        }
        wrapper.appendChild(message);
        notificationElem.appendChild(wrapper);
        // Add ripple if applicable, else just paint the full toast
        if (mainColor) {
            if (options.ripple) {
                ripple.style.background = mainColor;
                notificationElem.appendChild(ripple);
            } else notificationElem.style.background = mainColor;
        }
        // Add dismiss button
        if (options.dismissible) {
            var dismissWrapper = this._createHTMLElement({
                tagName: "div",
                className: "notyf__dismiss"
            });
            var dismissButton = this._createHTMLElement({
                tagName: "button",
                className: "notyf__dismiss-btn"
            });
            dismissWrapper.appendChild(dismissButton);
            wrapper.appendChild(dismissWrapper);
            notificationElem.classList.add("notyf__toast--dismissible");
            dismissButton.addEventListener("click", function(event) {
                var _a, _b;
                (_b = (_a = _this.events)[$defa8edbc79437a8$export$776308576d349339.Dismiss]) === null || _b === void 0 || _b.call(_a, {
                    target: notification,
                    event: event
                });
                event.stopPropagation();
            });
        }
        notificationElem.addEventListener("click", function(event) {
            var _a, _b;
            return (_b = (_a = _this.events)[$defa8edbc79437a8$export$776308576d349339.Click]) === null || _b === void 0 ? void 0 : _b.call(_a, {
                target: notification,
                event: event
            });
        });
        // Adjust margins depending on whether its an upper or lower notification
        var className = this.getYPosition(options) === "top" ? "upper" : "lower";
        notificationElem.classList.add("notyf__toast--" + className);
        return notificationElem;
    };
    NotyfView.prototype._createHTMLElement = function(_a) {
        var tagName = _a.tagName, className = _a.className, text = _a.text;
        var elem = document.createElement(tagName);
        if (className) elem.className = className;
        elem.textContent = text || null;
        return elem;
    };
    /**
     * Creates an invisible container which will announce the notyfs to
     * screen readers
     */ NotyfView.prototype._createA11yContainer = function() {
        var a11yContainer = this._createHTMLElement({
            tagName: "div",
            className: "notyf-announcer"
        });
        a11yContainer.setAttribute("aria-atomic", "true");
        a11yContainer.setAttribute("aria-live", "polite");
        // Set the a11y container to be visible hidden. Can't use display: none as
        // screen readers won't read it.
        a11yContainer.style.border = "0";
        a11yContainer.style.clip = "rect(0 0 0 0)";
        a11yContainer.style.height = "1px";
        a11yContainer.style.margin = "-1px";
        a11yContainer.style.overflow = "hidden";
        a11yContainer.style.padding = "0";
        a11yContainer.style.position = "absolute";
        a11yContainer.style.width = "1px";
        a11yContainer.style.outline = "0";
        document.body.appendChild(a11yContainer);
        this.a11yContainer = a11yContainer;
    };
    /**
     * Announces a message to screenreaders.
     */ NotyfView.prototype._announce = function(message) {
        var _this = this;
        this.a11yContainer.textContent = "";
        // This 100ms timeout is necessary for some browser + screen-reader combinations:
        // - Both JAWS and NVDA over IE11 will not announce anything without a non-zero timeout.
        // - With Chrome and IE11 with NVDA or JAWS, a repeated (identical) message won't be read a
        //   second time without clearing and then using a non-zero delay.
        // (using JAWS 17 at time of this writing).
        // https://github.com/angular/material2/blob/master/src/cdk/a11y/live-announcer/live-announcer.ts
        setTimeout(function() {
            _this.a11yContainer.textContent = message;
        }, 100);
    };
    /**
     * Determine which animationend event is supported
     */ NotyfView.prototype._getAnimationEndEventName = function() {
        var el = document.createElement("_fake");
        var transitions = {
            MozTransition: "animationend",
            OTransition: "oAnimationEnd",
            WebkitTransition: "webkitAnimationEnd",
            transition: "animationend"
        };
        var t;
        for(t in transitions){
            if (el.style[t] !== undefined) return transitions[t];
        }
        // No supported animation end event. Using "animationend" as a fallback
        return "animationend";
    };
    return NotyfView;
}();
/**
 * Main controller class. Defines the main Notyf API.
 */ var $defa8edbc79437a8$export$146ebdf5fc143718 = /** @class */ function() {
    function Notyf(opts) {
        var _this = this;
        this.dismiss = this._removeNotification;
        this.notifications = new $defa8edbc79437a8$export$7763ebb8bf460cea();
        this.view = new $defa8edbc79437a8$export$75d30b0f81ca0e5f();
        var types = this.registerTypes(opts);
        this.options = $defa8edbc79437a8$var$__assign($defa8edbc79437a8$var$__assign({}, $defa8edbc79437a8$export$93ca5d3f8675ae4c), opts);
        this.options.types = types;
        this.notifications.onUpdate(function(elem, type) {
            return _this.view.update(elem, type);
        });
        this.view.on($defa8edbc79437a8$export$776308576d349339.Dismiss, function(_a) {
            var target = _a.target, event = _a.event;
            _this._removeNotification(target);
            // tslint:disable-next-line: no-string-literal
            target["triggerEvent"]($defa8edbc79437a8$export$776308576d349339.Dismiss, event);
        });
        // tslint:disable-next-line: no-string-literal
        this.view.on($defa8edbc79437a8$export$776308576d349339.Click, function(_a) {
            var target = _a.target, event = _a.event;
            return target["triggerEvent"]($defa8edbc79437a8$export$776308576d349339.Click, event);
        });
    }
    Notyf.prototype.error = function(payload) {
        var options = this.normalizeOptions("error", payload);
        return this.open(options);
    };
    Notyf.prototype.success = function(payload) {
        var options = this.normalizeOptions("success", payload);
        return this.open(options);
    };
    Notyf.prototype.open = function(options) {
        var defaultOpts = this.options.types.find(function(_a) {
            var type = _a.type;
            return type === options.type;
        }) || {};
        var config = $defa8edbc79437a8$var$__assign($defa8edbc79437a8$var$__assign({}, defaultOpts), options);
        this.assignProps([
            "ripple",
            "position",
            "dismissible"
        ], config);
        var notification = new $defa8edbc79437a8$export$1efaef7de3802058(config);
        this._pushNotification(notification);
        return notification;
    };
    Notyf.prototype.dismissAll = function() {
        while(this.notifications.splice(0, 1));
    };
    /**
     * Assigns properties to a config object based on two rules:
     * 1. If the config object already sets that prop, leave it as so
     * 2. Otherwise, use the default prop from the global options
     *
     * It's intended to build the final config object to open a notification. e.g. if
     * 'dismissible' is not set, then use the value from the global config.
     *
     * @param props - properties to be assigned to the config object
     * @param config - object whose properties need to be set
     */ Notyf.prototype.assignProps = function(props, config) {
        var _this = this;
        props.forEach(function(prop) {
            // intentional double equality to check for both null and undefined
            config[prop] = config[prop] == null ? _this.options[prop] : config[prop];
        });
    };
    Notyf.prototype._pushNotification = function(notification) {
        var _this = this;
        this.notifications.push(notification);
        var duration = notification.options.duration !== undefined ? notification.options.duration : this.options.duration;
        if (duration) setTimeout(function() {
            return _this._removeNotification(notification);
        }, duration);
    };
    Notyf.prototype._removeNotification = function(notification) {
        var index = this.notifications.indexOf(notification);
        if (index !== -1) this.notifications.splice(index, 1);
    };
    Notyf.prototype.normalizeOptions = function(type, payload) {
        var options = {
            type: type
        };
        if (typeof payload === "string") options.message = payload;
        else if (typeof payload === "object") options = $defa8edbc79437a8$var$__assign($defa8edbc79437a8$var$__assign({}, options), payload);
        return options;
    };
    Notyf.prototype.registerTypes = function(opts) {
        var incomingTypes = (opts && opts.types || []).slice();
        var finalDefaultTypes = $defa8edbc79437a8$export$93ca5d3f8675ae4c.types.map(function(defaultType) {
            // find if there's a default type within the user input's types, if so, it means the user
            // wants to change some of the default settings
            var userTypeIdx = -1;
            incomingTypes.forEach(function(t, idx) {
                if (t.type === defaultType.type) userTypeIdx = idx;
            });
            var userType = userTypeIdx !== -1 ? incomingTypes.splice(userTypeIdx, 1)[0] : {};
            return $defa8edbc79437a8$var$__assign($defa8edbc79437a8$var$__assign({}, defaultType), userType);
        });
        return finalDefaultTypes.concat(incomingTypes);
    };
    return Notyf;
}();

});




//# sourceMappingURL=index.9598298e.js.map
